const env = process.env.REACT_APP_ENVIRONMENT;

const PRICES = {
  // Production & Development use live Stripe price IDs
  production: {
    monthly: 'price_1Sp3q1HFdskyUb7jH4FjFhxx',
    bimonthly: 'price_1ScSGCHFdskyUb7jKIZThFYu',
    // Listino 09/2026 (creati 29/08 in livemode). I price vecchi NON sono
    // archiviati: chi e' gia' abbonato resta sul suo, e sono la via di rollback.
    //   vecchio annualSchool     price_1Sd5MUHFdskyUb7jeTyTNd32  59,99
    //   vecchio annualUniversity price_1Sd5NXHFdskyUb7j8ISJ1yMt  69,99
    //
    // TRIMESTRALE, 16/09/2026: torna al price da 29,99, che non era mai stato
    // archiviato ed e' rimasto vivo sugli abbonati di prima. Il 39,99 del
    // listino 09/2026 (price_1U9q3THFdskyUb7jtpi5Z9zN) resta su Stripe, non si
    // archivia: e' il prezzo pieno che la carta mostra barrato, ed e' la via di
    // ritorno. Chi lo paga gia' resta dov'e'.
    //
    // Perche' (Stripe live, 20 prove scadute dal 04/09): a 39,99 arriva
    // all'addebito la stessa quota di sempre, 35% contro il 37% del 29,99, ma
    // gli addebiti che PASSANO crollano a 2 su 7 contro l'87%. Il 14 e 15
    // settembre i 29,99 sono passati 5 su 6, i 39,99 zero su 4: fondi
    // insufficienti, conto non valido, autorizzazione revocata. Non e' il
    // prezzo che scoraggia, e' l'importo in un colpo che la carta non regge.
    trimonthly: 'price_1Sd5RbHFdskyUb7jv1f2LdVQ',
    //
    // ANNUALI, 16/09/2026: tornano al listino di prima, 59,99 e 69,99. I price
    // del 09/2026 (99,99 price_1U9q5oH..., 109,99 price_1U9q6WH...) restano su
    // Stripe, non si archiviano: sono la via di ritorno.
    //
    // Perche' (Stripe live, letto il 16/09): in diciotto giorni di vendita i
    // due price nuovi hanno fatto ZERO abbonamenti. I vecchi, che non sono mai
    // stati archiviati, ne hanno 58 e 17 ancora attivi oggi: sono la seconda e
    // la quarta coorte pagante dell'azienda.
    //
    // Non e' solo stagione (gli annuali si vendono a febbraio e marzo, 11 e 14
    // pezzi). E' che il piano lungo aveva smesso di convenire: col 3 Mesi a
    // 29,99 l'Anno Scolastico a 99,99 costa 10,00 al mese esatti come lui, cioe'
    // zero risparmio in cambio di dieci mesi di impegno, e il 12 Mesi a 109,99
    // ne fa risparmiare l'8%. A 69,99 il 12 Mesi torna a 5,83 al mese contro
    // 10,00, che e' il 42% in meno: quello e' un motivo per impegnarsi.
    annualSchool: 'price_1Sd5MUHFdskyUb7jeTyTNd32',
    annualUniversity: 'price_1Sd5NXHFdskyUb7j8ISJ1yMt',
    maturita: 'price_1TCfxGHFdskyUb7jDFxSZA5q',
  },
  // Preproduction uses Stripe test mode price IDs
  preproduction: {
    // Esiste in test mode anche un mensile a 14,99 (price_1UEaeMHFdskyUb7jx0DdNZIx,
    // creato l'11/09/2026) e NON si vende: il taglio di listino e' rientrato lo
    // stesso giorno. Il motivo sta in STU-348: chi ha scritto "costa troppo" era
    // in prova sul TRIMESTRALE, non sul mensile.
    monthly: 'price_1T8zQWHFdskyUb7jLC9ukoB8',
    bimonthly: 'price_1Scmb0HFdskyUb7jtjHCzIyA',
    // Listino 09/2026 in TEST mode, creati l'08/09 (STU-313) sugli stessi
    // prodotti di test: 39,99 / 99,99 ogni 10 mesi / 109,99 ogni 12 mesi.
    // Il trimestrale segue il live e torna al gemello da 29,99 in test mode
    // (price_1T8zSeHFdskyUb7ju8tPFZkV, quello in uso fino all'08/09). Il 39,99
    // di test resta price_1UDWKWHFdskyUb7jgYa1zkC4.
    trimonthly: 'price_1T8zSeHFdskyUb7ju8tPFZkV',
    // Gli annuali seguono il live e tornano ai gemelli di test in uso fino
    // all'08/09. I price di test del listino 09/2026 restano:
    // 99,99 price_1UDWKXHFdskyUb7j4exRwuCm, 109,99 price_1UDWKYHFdskyUb7jtwIvIuP0.
    annualSchool: 'price_1T8zTZHFdskyUb7jPrwuMpK5',
    annualUniversity: 'price_1T8zTBHFdskyUb7jfpVozQ8B',
    maturita: 'price_1TCjfSHFdskyUb7jptKeDrxP',
  },
};

// Development falls back to production prices (same Stripe account)
PRICES.development = PRICES.production;

export const STRIPE_PRICES = PRICES[env] || PRICES.production;

// ─── Cifre MOSTRATE ──────────────────────────────────────────────────────────
// Stanno QUI, accanto agli ID, e non piu' sparse fra JSX cablato e i18n. Il
// motivo non e' ordine: prezzo mostrato e prezzo addebitato vivevano in due
// posti scollegati, quindi POTEVANO divergere — e su un ambiente con price id
// diversi (preprod usa il test mode) divergevano per forza appena si cambiava
// il listino da una parte sola.
//
// `months` serve a derivare due cose che prima erano numeri inventati:
//   - il prezzo BARRATO = quanto costa lo stesso periodo pagando mese per mese
//   - l'equivalente mensile mostrato sulle carte lunghe
// Cosi' lo sconto che la carta calcola coincide sempre con lo sconto reale.
// Prima i barrati erano cablati (49,99 / 129,99 / 159,99) e non corrispondevano
// a niente: il toggle diceva -50%, le carte 54% e 56%, il vero era -70%.
const AMOUNTS = {
  production: {
    monthly: { cost: 19.99, months: 1 },
    bimonthly: { cost: 24.99, months: 2 },
    trimonthly: { cost: 29.99, months: 3, prezzoPieno: 39.99 },
    annualSchool: { cost: 59.99, months: 10 },
    annualUniversity: { cost: 69.99, months: 12 },
  },
};
// Dall'08/09/2026 il listino 09/2026 esiste anche in TEST mode: preprod mostra
// e addebita le stesse cifre di produzione (prima divergeva, decisione 30/08).
AMOUNTS.preproduction = AMOUNTS.production;
AMOUNTS.development = AMOUNTS.production;

const CURRENT = AMOUNTS[env] || AMOUNTS.production;

// "39,99" — formato italiano, due decimali, come lo stampano le carte.
const it = (n) => n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Cifre di un piano, gia' formattate per la carta.
 *  cost         prezzo del periodo            "29,99"
 *  originalCost il barrato                    "39,99"  (prezzo pieno del piano)
 *  perMonth     equivalente mensile           "10,00"
 *  months       durata in mesi
 * `originalCost` e' null sul mensile: non ha senso barrare se stesso. Sui piani
 * senza `prezzoPieno` resta il costo mese per mese dello stesso periodo.
 */
export const planAmounts = (plan) => {
  const a = CURRENT[plan];
  if (!a) return null;
  const monthly = CURRENT.monthly.cost;
  const listino = monthly * a.months;
  // Il prezzo a cui il piano torna a fine offerta, se e' in offerta; altrimenti
  // il costo mese per mese dello stesso periodo. Solo per i piani a piu' mesi:
  // il mensile non ha senso che barri se stesso.
  const pieno = a.months > 1 ? (a.prezzoPieno || listino) : 0;
  return {
    months: a.months,
    // `amount` e' il NUMERO. Serve dove si fa aritmetica o si passa un valore
    // agli analytics: `parseFloat("39,99")` vale 39, non 39,99, e il Pixel
    // avrebbe mandato un revenue sbagliato del 2,5%.
    amount: a.cost,
    cost: it(a.cost),
    perDay: it(a.cost / (a.months * 30)),
    perMonth: it(a.cost / a.months),
    // Il BARRATO. Di norma e' quanto costa lo stesso periodo pagando mese per
    // mese (19,99 x 3 = 59,97). Quando un piano ha un `prezzoPieno` -- cioe' e'
    // in offerta rispetto al proprio listino, non rispetto al mensile -- vince
    // quello: barrare 59,97 accanto a 29,99 direbbe una cosa vera ma non
    // QUESTA, e nasconderebbe che il prezzo pieno del piano e' 39,99 e che il
    // 1o ottobre ci torna.
    //
    // `prezzoPieno` non e' un numero inventato come i vecchi barrati cablati:
    // e' il price che sta su Stripe accanto a questo, mai archiviato, e che
    // torna in vendita a fine offerta.
    originalCost: pieno > a.cost ? it(pieno) : null,
    // Il prezzo pieno DICHIARATO del piano, cioe' la cifra a cui torna a fine
    // offerta. Null su tutti i piani che non sono in offerta: li' il barrato
    // sarebbe il costo mese per mese, che la carta racconta gia' con la riga
    // del risparmio e che barrato direbbe una cosa diversa.
    prezzoPieno: a.prezzoPieno ? it(a.prezzoPieno) : null,
    savingPercent: pieno > a.cost
      ? Math.round(((pieno - a.cost) / pieno) * 100)
      : null,
  };
};

export const STRIPE_AMOUNTS = CURRENT;

// Cloud Functions region per environment
// Production extension is in us-central1, preprod in europe-west1
const REGIONS = {
  production: 'us-central1',
  preproduction: 'europe-west1',
  development: 'us-central1',
};

export const STRIPE_EXTENSION_REGION = REGIONS[env] || REGIONS.production;
